import { type PartialPropsOf } from '@blaze-runtime/engine-domain';

import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';

export const signatureV4Migration: PropsMigration = {
  mode: 'props',
  description: 'Migrate Signature element to v4 by migrating hideDate option to detailsType',
  run: (props: PartialPropsOf<'signature'>): void => {
    if (props?.content?.options?.hideDate) {
      props.content = {
        ...props.content,
        options: {
          ...props.content?.options,
          detailsType: 'name',
        },
      };
    }
  },
};
